import { useQuery } from "react-query";
import { getData } from "../../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../../api/ajax-endpoints";

const DEFAULT_COUNTRY_ISO2_CODE = "NG";

type TNextOfKinCountryState = {
  id: number;
  name: string;
};

type TNextOfKinCountryStatesResponse = {
  data: TNextOfKinCountryState[];
  message?: string;
  status?: boolean;
  status_code?: number;
};

const getNextOfKinCountryStates = async (countryIso2Code: string) => {
  const encodedCountryIso2Code = encodeURIComponent(countryIso2Code);
  const { data } = await getData(
    `${ajaxEndpoints.COUNTRY_STATES}?iso2_code_country=${encodedCountryIso2Code}`,
  );
  return data;
};

export default function useNextOfKinCountryStates(countryIso2Code?: string) {
  const resolvedCountryIso2Code = countryIso2Code || DEFAULT_COUNTRY_ISO2_CODE;

  return useQuery<TNextOfKinCountryStatesResponse>(
    ["getNextOfKinCountryStates", resolvedCountryIso2Code],
    () => getNextOfKinCountryStates(resolvedCountryIso2Code),
    {
      refetchOnWindowFocus: true,
    },
  );
}
